
<template>

	<mymodal ref="modal" title="Согласование подходов" ok="Сохранить" :reset="reset" :check="check" :submit="submit" :ok_disabled="data.not_editable || !check_roles([ 'cost' ])">

		<b-row>

			<b-col>Наименование подхода</b-col>
			<b-col>Вес подхода (100%)</b-col>

		</b-row>

		<b-row class="mt-2">

			<b-col>Сравнительный</b-col>
			<b-col>

				<b-form-input v-model="comparative" type="number" :state="comparative_state" :disabled="comparative_disabled || data.not_editable || !check_roles([ 'cost' ])" invalid-feedback="Необходимо ввести корректное значение" v-on:input="check" :accuracy="0" />

			</b-col>

		</b-row>

		<b-row class="mt-2">

			<b-col>Затратный</b-col>
			<b-col>

				<b-form-input v-model="expensive" type="number" :state="expensive_state" :disabled="expensive_disabled || data.not_editable || !check_roles([ 'cost' ])" invalid-feedback="Необходимо ввести корректное значение" v-on:input="check" :accuracy="0" />

			</b-col>

		</b-row>

		<b-row class="mt-2">

			<b-col>Доходный</b-col>
			<b-col>

				<b-form-input v-model="profitable" type="number" :state="profitable_state" :disabled="profitable_disabled || data.not_editable || !check_roles([ 'cost' ])" invalid-feedback="Необходимо ввести корректное значение" v-on:input="check" :accuracy="0" />

			</b-col>

		</b-row>

		<b-form-invalid-feedback class="mt-2" :state="sum_state">Сумма значений должна быть равна 100%</b-form-invalid-feedback>

	</mymodal>

</template>

<script>

import api from "../../../../api"
import mymodal from "../../../widgets/modal"

export default
{
	props :
	{
		id : String,
		data : Object,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			service : "cadastral_groups",

			comparative : null,
			expensive : null,
			profitable : null,

			comparative_disabled : false,
			expensive_disabled : false,
			profitable_disabled : false,

			comparative_state : null,
			expensive_state : null,
			profitable_state : null,
			sum_state : null,

		}
	},

	watch :
	{
		data :
		{
			immediate : true,

			handler(data)
			{
				if(data)
				{
					if(data.cost_evaluation_comparative == null)
						this.comparative_disabled = true
					else
					{
						this.comparative_disabled = false
						this.comparative = data.cost_evaluation_comparative_coef
					}

					if(data.cost_evaluation_expensive == null)
						this.expensive_disabled = true
					else
					{
						this.expensive_disabled = false
						this.expensive = data.cost_evaluation_expensive_coef
					}

					if(data.cost_evaluation_profitable == null)
						this.profitable_disabled = true
					else
					{
						this.profitable_disabled = false
						this.profitable = data.cost_evaluation_profitable_coef
					}
				}
			}
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},
		
		check()
		{
			const comparative = Number(this.comparative)
			const expensive = Number(this.expensive)
			const profitable = Number(this.profitable)

			this.comparative_state = this.comparative_disabled || ( ! isNaN(comparative) && comparative >= 0 )
			this.expensive_state = this.expensive_disabled || ( ! isNaN(expensive) && expensive >= 0 )
			this.profitable_state = this.profitable_disabled || ( ! isNaN(profitable) && profitable >= 0 )

			var sum = 0

			if(! this.comparative_disabled)
				sum += comparative

			if(! this.expensive_disabled)
				sum += expensive

			if(! this.profitable_disabled)
				sum += profitable

			this.sum_state = sum == 100

			return this.comparative_state && this.expensive_state && this.profitable_state && this.sum_state
		},

		reset()
		{
			this.comparative_state = null
			this.expensive_state = null
			this.profitable_state = null
			this.sum_state = null
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			var fields = {}

			if(! this.comparative_disabled)
				fields.cost_evaluation_comparative_coef = Number(this.comparative)

			if(! this.expensive_disabled)
				fields.cost_evaluation_expensive_coef = Number(this.expensive)

			if(! this.profitable_disabled)
				fields.cost_evaluation_profitable_coef = Number(this.profitable)

			api.call(this, this.service, "edit", { id : this.id, fields : fields }, () => {})
		},
	}
}

</script>

